import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: auto;
  padding: 2rem 16rem;
  display: flex;
  align-items: center;
  flex-direction: column;

  @media screen and (max-width: 1032px) {
    width: 100%;
    padding: 0 1rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    
  }
`;
export const Content = styled.div`
  width: 1026px;
  height: auto;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  padding: 1rem 1rem;

  @media screen and (max-width: 800px){
    width: 100%;
    /* padding: 0 1rem; */

    h2{
      font-size:  ${({theme}) => theme?.headings.h2Mobile?.fontSize};
    }
  }


  .sessaoDoacoes {
    padding-top: 1rem;

    h2{
      font-size:  ${({theme}) => theme?.headings.h3Mobile?.fontSize};

      @media screen and (max-width: 768px){
        display: none;
      }
    }

    div {
      padding-top: 0.4rem;
      display: flex;
      flex-wrap: wrap;
      gap: 0.2rem;
      p {
        font-weight: 200;
        @media screen and (max-width: 768px) {
          text-align: justify;
          font-size: ${({ theme }) => theme?.paragraphs.P2Mobile.fontSize};
        }
      }
      p:nth-child(2) {
        color: ${({ theme }) => theme.colors.primary};

        @media screen and (max-width: 768px) {
          color: ${({ theme }) => theme.colors.gray}
        }
      }
      @media screen and (max-width: 768px) {
        display: flex ;
      }
    }
  }

  .sessaoPix {
    padding-top: 1rem;
    > p:first-child {
      color: ${({ theme }) => theme.colors.primary};

      @media screen and (max-width: 768px) {
        color: #000;
      }
    }
    section{
      display: flex;
      gap: 0.4rem;

      p:nth-child(1) {
        font-weight: 200;
        color: ${({ theme }) => theme.paragraphs.PMobile}
      }
      p:nth-child(2) {
        font-weight: bold;

        @media screen and (max-width: 768px) {
          font-weight: 200;
        } 
      }

      @media screen and (max-width: 768px) {
        display: flex;
        flex-direction: column;

        div{
          display: flex;
          align-items: center;
          gap: 0.2rem;
        }

      }
    }
  }
`;
export const FirstSection = styled.section`
  padding-top: 1rem;
  display: flex;

  img:nth-child(2){
    display: none;
  }
  
  @media screen and (max-width: 768px) {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 1.5rem;
      gap: 1rem;

      img:nth-child(2){
        display: flex;
        width: 250px;
        height: 166px;
      }

      img:nth-child(1){
        display: none;
      }
  }

  p {
    padding-bottom: 0.2rem;
    font-weight: 550;
  }
  div {
    margin-left: 2rem;
    display: flex;
    flex-direction: column;
    height: 10rem;
    p:last-child {
      padding-top: 2rem;
    }

    @media screen and (max-width: 768px) {
      display:  none

    }
  }
  ul {
    padding-left: 1rem;
    li {
      font-size: 0.8rem;
      font-weight: 550;
    }

  }
`;

export const Image = styled.img`
  width: 228px;
  height: 239px;
`;

export const SecondSection = styled.section`
  padding-top: 2rem;
  display: flex;
  flex-direction: column;
  > h2 {
    color: ${({ theme }) => theme.colors.primary};

    @media screen and (max-width: 768px) {
      color: #000;
      font-size: ${({ theme }) => theme.headings.h1Mobile};
      margin-bottom: 0.5rem;

    }
  }


  section {
    .sessao {
      padding-top: 0.5rem;
      padding-bottom: 0.5rem;
      display: flex;
      justify-content: space-between;


      ul {
        list-style: none;
      }
      .block1 {
        padding-top: 1rem;
        padding-bottom: 2rem;


        @media screen and (max-width: 768px) {

          padding-top: 0.2rem;
          padding-bottom: 1rem;
          h2{
          font-size: ${({ theme }) => theme.headings.h2Mobile};
          }

          ul{
            li{
              font-size: ${({ theme }) => theme.paragraphs.P3Mobile};
            }
          }
        }

        
      }

      @media screen and (max-width: 768px) {
        display: flex;
        flex-direction: column;
      }
    }

    .SectionImages {
      display: flex;
      align-items: center;
      gap: 1rem;

      @media screen and (max-width: 800px){
        display: none;
      }

      img:first-child {
        width: 167px;
        height: 167px;
      }
      div {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        img:first-child {
          width: 250px;
          height: 166px;
        }
        img:last-child {
          width: 199px;
          height: 166px;
        }
        @media screen and (max-width: 768px) {
          display: none;
        }
      }
    }
  }
  .sessao2 {
    
    > h2:nth-child(1) {
      color: ${({ theme }) => theme.colors.primary};

      @media screen and (max-width: 768px) {
        color: #000;
        font-size: ${({ theme }) => theme.headings.h1Mobile};
        padding-bottom: 0.5rem;
        align-self: stretch;
      }
    }
    div {
      a {
        text-decoration: none;
      }
      p:nth-child(1) {
        padding-top: 0.2rem;
        font-weight: 300;

        @media screen and (max-width: 768px) {
          font-size: ${({ theme }) => theme.paragraphs.PMobile};
        }
      }
      p:last-child {
        padding-top: 1.5rem;
      }
    }

    @media screen and (max-width: 768px) {
      display: flex;
      width: 100%;
      gap: 0.4rem;
      flex-direction: column;
      align-items: center;

      img{
        display: flex !important;
        padding-top: 1.5rem;
        padding-bottom: 1rem;
      }
    }

    img{
      display: none;
    }
  }
`;

export const ThirdSection = styled.section`
  padding-top: 1rem;
  .first-section{
    > h2 {
      padding-bottom: 0.5rem;
      @media screen and (max-width: 768px){
        font-size: ${({ theme }) => theme.headings.h2Mobile};
      }
    }
    p {
      font-weight: 200;
      font-size: ${({ theme }) => theme.paragraphs.P2};
      @media screen and(max-width: 768px){
        font-size: ${({ theme }) => theme.paragraphs.PMobile};
      }
    }

    img{
      display: none;

      @media screen and (max-width: 768px){
        display: flex;
        padding: 1.5rem 0;
      }
    }

    @media screen and (max-width: 768px){
      display: flex;
      flex-direction: column;
      align-items: center;

      > h2 {
        align-self: stretch;
      }
    }
  
  }
  .second-section{
    p:nth-child(1) {
      color: ${({ theme }) => theme.colors.primary};
      padding-top: 0.5rem;

      @media screen and (max-width: 768px) {
        color: #000;
        align-self: stretch;
      }
    }
    p:nth-child(2) {
      font-weight: 200;
      padding-top: 0.5rem;

      @media screen and (max-width: 768px) {
        font-size: ${({ theme }) => theme.paragraphs.P2Mobile};
        padding-top: 0.5rem;
        padding-bottom: 1rem;
      }
    }

    @media screen and (max-width: 1000px) {
      display: flex;
      flex-direction: column;
      align-items: center;

      img{
        display: flex !important;
      }
    }

    img{
      display: none;
    }
  }
  .Container {
    display: flex;
    padding-top: 1.5rem;

    @media screen and (max-width: 1000px) {
        display: flex;
        flex-direction: column;
      }

    .block1 {
      p:nth-child(1) {  
        display: flex;
        flex-direction: column;
        margin-top: 2rem;
      }
      p {
        font-size: 0.9rem;
        font-weight: 600;
      }
      h2 {
        font-weight: 600;
        font-size: 0.8rem;
        padding-top: 1rem;
      }
      ul {
        li {
          font-size: 0.8rem;
          font-weight: 600;
        }
        padding-top: 0.5rem;
        padding-bottom: 1.5rem;
        list-style: none;
      }
      img{
        display: none;
        @media screen and (max-width: 768px) {
          display: flex;
          padding-top: 1rem;
        }
      }

      @media screen and (max-width: 768px) {
        display: flex;
        flex-direction: column;
        align-items: center;

        ul,p,h2{
          align-self: stretch;
        }

        h2{
          font-size: ${({ theme }) => theme.headings.h2Mobile};
        }
        p{
          font-size: ${({ theme }) => theme.paragraphs.P};
        }
      }
    }
    .SectionImages2 {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      @media screen and (max-width: 800px) {
        display: none;
      }

      img:first-child {
        width: 168px;
        height: 253px;
      }
      div {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        img:first-child {
          width: 253px;
          height: 253px;
        }
        img:last-child {
          width: 283px;
          height: 173px;
        }
      }
    }
  }
`;
export const FouthSection = styled.section`
  padding-top: 2rem;


  @media screen and (max-width: 768px){
    h2{
      font-size: ${({ theme }) => theme.headings.h2Mobile};
      padding-top: 1rem;
      align-self: stretch;
    }
    p{
      font-size: ${({ theme }) => theme.paragraphs.P2Mobile};
      align-self: stretch;
    }

    display: flex;
    flex-direction: column;
    align-items: center;

    .img{
      display: flex;
    }
  }
  
  .img{
    display: none;
  }

  button{
    @media screen and (max-width: 768px){
      display: flex !important;
      margin: 0.3rem auto;
    }

    display: none;
  }

  p {
    padding-top: 1.5rem;
    padding-bottom: 1rem;
    font-size: 1rem;
    font-weight: 300;
  }
  .cards {
    padding-top: 2rem;
    padding-bottom: 4rem;
    display: flex;
    justify-content: space-between;

    @media screen and (max-width: 900px){
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 2rem;

      img{
        width: 50% !important;
      }
    }
    @media screen and (max-width: 768px) {
        display: none;
    }

    img:first-child {
      width: 240px;
      height: 300px;
    }
    img:nth-child(2) {
      width: 300px;
      height: 300px;
    }
    img:last-child {
      width: 240.06px;
      height: 300px;
    }


  }
`;

export const LastSection = styled.section`
  padding-top: 3rem;

  @media screen and (max-width: 768px) {
    width: 100%;
  }
  h2 {
    text-align: center;
    @media screen and (max-width: 768px){
      font-size: ${({ theme }) => theme.headings.h2Mobile};
    }
  }
  .cardsParceiros {
    width: 100%;
    padding-top: 1rem;
    justify-content: center;
    display: flex;
    flex-wrap: wrap;
    gap: 0.4rem;

    @media screen and (max-width: 768px) {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        padding-bottom: 1.5rem;
    
        img:nth-child(1){
          width: 50px !important;
        }
        img:nth-child(2){
          width: 167.67px;
        }img:nth-child(3){
          width: 50px;
        }img:nth-child(4){
          width: 122.95px;
        }img:nth-child(5){
          width: 100px;
        }
        img:nth-child(6){
          width: 68.67px;
        }img:nth-child(7){
          width: 82.48px;
        }img:nth-child(8){
          width: 181.27px;
        }img:nth-child(9){
          width: 43.12px;
        }img:nth-child(10){
          width: 70.18px;
        }img:nth-child(11){
          width: 84.01px;
        }img:nth-child(12){
          width: 49.88px;
        }img:nth-child(13){
          width: 46.62px;
        }img:nth-child(14){
          width: 50px;
        }img:nth-child(15){
          width: 134.38px;
        }img:nth-child(16){
          width: 49.43px;
        }img:nth-child(17){
          width: 132.73px;
        }img:nth-child(18){
          width: 118.83px;
        }img:nth-child(19){
          width: 50px;
        }img:nth-child(20){
          width: 50px;
        }img:nth-child(21){
          width: 103.76px;
        }img:nth-child(22){
          width: 150.5px;
        }img:nth-child(23){
          width: 50.46px;
        }img:nth-child(24){
          width: 91.17px;
        }img:nth-child(25){
          width: 50px;
        }img:nth-child(26){
          width: 50px;
        }img:nth-child(27){
          width: 179.38px;
        }img:nth-child(28){
          width: 50px;
        }img:nth-child(29){
          width: 50px;
        }img:nth-child(30){
          width: 38.7px;
        }img:nth-child(31){
          width: 77.09px;
        }img:nth-child(32){
          width: 50px;
        }img:nth-child(33){
          width: 50px;
        }img:nth-child(34){
          width: 50px;
        }img:nth-child(35){
          width: 50px;
        }img:nth-child(36){
          width: 92.86px;
        }img:nth-child(37){
          width: 50.13px;
        }img:nth-child(38){
          width: 145.55px;
        }img:nth-child(39){
          width: 60.13px;
        }
        img:nth-child(40){
          width: 50px;
        }
        img:nth-child(41){
          width: 50.75px;
        }
        img:nth-child(42){
          width: 50.36px;
        }
        img:nth-child(43){
          width: 55.05px;
        }
        img:nth-child(44){
          width: 124.34px;
        }
        img:nth-child(45){
          width: 156.4px;
        }

        img{
          height: 50px !important;
        }
      }
  }
`;
